import { FETCH_COUNTRIES, SAVE_FETCH_COUNTRIES } from "appRedux/constants";

const INIT_STATE = {
  loading: null,
  countries: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_FETCH_COUNTRIES: {
      return {
        ...state,
        loading: false,
        countries: action.payload
      };
    }
    case FETCH_COUNTRIES: {
      return {
        ...state,
        loading: true
      };
    }
    default:
      return state;
  }
};
